// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TXgWkYqkLH5B\\+GlxDCRBnA\\=\\= {\n  display: flex;\n  flex-flow: column nowrap;\n  gap: 8px;\n}\n", "",{"version":3,"sources":["webpack://src/pages/consultivo/cartoes/_ConsultaCollection.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,wBAAA;EACA,QAAA;AACF","sourcesContent":[".ConsultaCollection {\n  display: flex;\n  flex-flow: column nowrap;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ConsultaCollection": "TXgWkYqkLH5B+GlxDCRBnA=="
};
export default ___CSS_LOADER_EXPORT___;
